import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"height":"440px","overflow-y":"scroll"} }


import { ref, defineExpose, unref, defineEmits } from 'vue'
import { ElDialog, ElButton, ElMessage } from 'element-plus'
const __default__ = {
  name: 'HighLighData'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['on-submit'],
  setup(__props, { expose: __expose, emit: __emit }) {

const dialogVisible = ref(false)
const highLightStr = ref('')
// 定义外部事件
const emits = __emit
// 显示，由父组件调用
const show = () => {
  dialogVisible.value = true
}

// 处理确定按钮事件
const handleSubmit = () => {
  if (unref(highLightStr)) {
    emits('on-submit', unref(highLightStr))
    dialogVisible.value = false
  } else {
    ElMessage.error('导入数据不能为空')
  }
}
const handleClose = () => {
  dialogVisible.value = false
  highLightStr.value = ''
}
__expose({
  show
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    title: "导入高亮数据(json)",
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
    width: "60%",
    onClose: handleClose,
    "custom-class": "m-dialog-high-light-data",
    "append-to-body": true
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(ElButton), { onClick: handleClose }, {
        default: _withCtx(() => [
          _createTextVNode("取 消")
        ]),
        _: 1
      }),
      _createVNode(_unref(ElButton), {
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode("确 定")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_input, {
          modelValue: highLightStr.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((highLightStr).value = $event)),
          rows: 20,
          type: "textarea"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})